import Vue from 'vue';
import { mapState } from 'vuex';
import * as api from '../../../scripts/services/api';
import * as blockui from '../../../helpers/block-ui';
import * as dateFormat from '../../../helpers/dateFormat';
import * as swal from '../../../helpers/swal';
import { DateRangePickerComponent } from '@syncfusion/ej2-vue-calendars';
import { getWorkOrderLocks } from '../../../scripts/services/workOrderLocks';

export default {
  components: {
    "ejs-daterangepicker": DateRangePickerComponent
  },
  data() {
    return {
      // Saha uygulamasında kilitli iş emirleri: `{ [workOrderId]: kilit }`.
      // Kilitliyken web'den yazmak sunucuda engelleniyor; liste bunu rozetle söylüyor.
      locks: {},

      overdueDateRange: [],
      upcomingDateRange: [],

      overdueWorkOrders: [],
      todayWorkOrders: [],
      upcomingWorkOrders: [],

      overdueWorkOrdersDaily: [],
      todayWorkOrdersDaily: [],
      upcomingWorkOrdersDaily: [],

      overdueWorkOrdersTemp: [],
      todayWorkOrdersTemp: [],
      upcomingWorkOrdersTemp: [],

      overdueWorkOrdersDailyTemp: [],
      todayWorkOrdersDailyTemp: [],
      upcomingWorkOrdersDailyTemp: [],

      statuses: [],
      min: 1,
      max: 30,

      overdueWaterMark: 'Tarih seçiniz...',
      upcomingWaterMark: 'Tarih seçiniz...',

      dateFormatDD_MMM_YYYY: 'dd MMMM yyyy',
      seperator: ' - ',

      isActivePaneDaliyWorkOrders: false,
      workOrders: [],
    };
  },
  async mounted() {
    const self = this;
    self.getWorkOrderStatusList();
    self.loadLocks();
    self.init();
    self.$eventHub.$on('changeWOStatus', self.init);
    document.querySelector('.m-content').style.padding = '0px 0px';
  },
  computed: {
    ...mapState({
      workOrderStatuses: (state) => state.enums.workOrderStatus,
      workOrderSourceEnums: (state) => state.enums.workOrderSource,
    }),
    yesterday() {
      return moment().add(-1, 'days').hour(23).minute(59).second(59).toDate()
    },
    today() {
      return moment().toDate();
    },
    tomorrow() {
      return moment().add(1, 'days').hour(0).minute(0).second(0).toDate();
    },
  },
  methods: {
    async loadLocks() {
      // Kilit bilgisi listenin kendisiyle gelmiyor (iş emri listeleri veritabanında tanımlı
      // view'lar); ayrı ve tek bir çağrıyla alınıyor. Hata durumunda boş dönüyor: rozetin
      // çıkmaması, listenin hiç açılmamasından iyi.
      this.locks = await getWorkOrderLocks();
    },

    lockTitle(workOrderId) {
      const lock = this.locks[workOrderId];
      if (!lock) return '';
      return lock.IsMine
        ? this.translate('work_order_locked_by_me')
        : this.translate('work_order_locked_by', { name: lock.LockedByName || '' });
    },

    async init() {
      const self = this;
      blockui.pageBlock();

      const promises = [
        self.getWorkOrderDateRange(),
        self.getTodayWorkOrders(),
      ];

      await Promise.all(promises);
      blockui.unBlockPage();
    },
    getWorkOrderStatusList() {
      const self = this;
      api.getWorkOrderStatusList(null).then((res) => {
        self.statuses = res.body.Data;
      });
    },
    getWorkOrderDateRange() {
      const self = this;

      api.getWorkOrderDateRange().then((response) => {
        if (response.body.IsSuccess && response.body.Data.length > 0) {
          const data = response.body.Data;

          const overdueStartDayCount = parseInt(data.filter(x => x.Key == "MyTaskPreviousDayCount")[0].Value) * -1;
          const overdueEndDayCount = -1;

          const upcomingStartDayCount = 1;
          const upcomingEndDayCount = parseInt(data.filter(x => x.Key == "MyTaskNextDayCount")[0].Value);

          const overdueStartDate = moment().add(overdueStartDayCount, 'days').toDate()
          const overdueEndDate = moment().add(overdueEndDayCount, 'days').toDate()

          const upcomingStartDate = moment().add(upcomingStartDayCount, 'days').toDate()
          const upcomingEndDate = moment().add(upcomingEndDayCount, 'days').toDate()

          Vue.set(self, 'overdueDateRange', [overdueStartDate, overdueEndDate]);
          this.$nextTick();
          Vue.set(self, 'upcomingDateRange', [upcomingStartDate, upcomingEndDate]);
          this.$nextTick();
        }
      });
    },
    getWorkOrders(startDate, endDate, isOverdueWorkOrders) {
      const self = this;
      api.getDailyMyWorkOrders(startDate, endDate).then((response) => {
        if (response.body.IsSuccess) {
          this.workOrders = response.body.Data;
          if (isOverdueWorkOrders) {
            Vue.set(self.overdueWorkOrders, 0, this.workOrders.filter((wo) => !wo.IsDailyWorkOrderCategory).sort(self.compareDatesDESC));
            Vue.set(self.overdueWorkOrdersDaily, 0, this.workOrders.filter((wo) => wo.IsDailyWorkOrderCategory).sort(self.compareDatesDESC));

            Vue.set(self.overdueWorkOrdersTemp, 0, this.workOrders.filter((wo) => !wo.IsDailyWorkOrderCategory).sort(self.compareDatesDESC));
            Vue.set(self.overdueWorkOrdersDailyTemp, 0, this.workOrders.filter((wo) => wo.IsDailyWorkOrderCategory).sort(self.compareDatesDESC));
          }
          else {
            Vue.set(self.upcomingWorkOrders, 0, this.workOrders.filter((wo) => !wo.IsDailyWorkOrderCategory).sort(self.compareDatesASC));
            Vue.set(self.upcomingWorkOrdersDaily, 0, this.workOrders.filter((wo) => wo.IsDailyWorkOrderCategory).sort(self.compareDatesASC));

            Vue.set(self.upcomingWorkOrdersTemp, 0, this.workOrders.filter((wo) => !wo.IsDailyWorkOrderCategory).sort(self.compareDatesASC));
            Vue.set(self.upcomingWorkOrdersDailyTemp, 0, this.workOrders.filter((wo) => wo.IsDailyWorkOrderCategory).sort(self.compareDatesASC));
          }
        }
      }, (error) => {
      });
    },
    getTodayWorkOrders() {
      const self = this;
      api.getTodayWorkOrders().then((response) => {
        if (response.body.IsSuccess) {
          this.workOrders = response.body.Data;
          Vue.set(self.todayWorkOrders, 0, this.workOrders.filter((wo) => !wo.IsDailyWorkOrderCategory).sort(self.compareDatesDESC));
          Vue.set(self.todayWorkOrdersDaily, 0, this.workOrders.filter((wo) => wo.IsDailyWorkOrderCategory).sort(self.compareDatesDESC));

          Vue.set(self.todayWorkOrdersTemp, 0, this.workOrders.filter((wo) => !wo.IsDailyWorkOrderCategory).sort(self.compareDatesDESC));
          Vue.set(self.todayWorkOrdersDailyTemp, 0, this.workOrders.filter((wo) => wo.IsDailyWorkOrderCategory).sort(self.compareDatesDESC));
        }
      });
    },
    compareDatesDESC(a, b) {
      if (new Date(a.ScheduledTime) < new Date(b.ScheduledTime)) {
        return 1;
      } if (new Date(a.ScheduledTime) > new Date(b.ScheduledTime)) {
        return -1;
      }
      return 0;
    },
    compareDatesASC(a, b) {
      if (new Date(a.ScheduledTime) < new Date(b.ScheduledTime)) {
        return -1;
      } if (new Date(a.ScheduledTime) > new Date(b.ScheduledTime)) {
        return 1;
      }
      return 0;
    },
    viewDateTimeFormat(date) {
      return dateFormat.viewDateTimeFormat(date);
    },
    viewDateFormat(date) {
      return dateFormat.viewDateFormat(date);
    },
    viewRelativeDateTimeFormat(date) {
      return dateFormat.viewRelativeDateTimeFormat(date);
    },
    passDateParameter(date) {
      return moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD')
    },
    routeToMyWorkOrder(workOrderId) { 
      const allWorkOrders = [
        ...(this.workOrders || []),
        ...(this.overdueWorkOrders[0] || []),
        ...(this.overdueWorkOrdersDaily[0] || []),
        ...(this.upcomingWorkOrders[0] || []),
        ...(this.upcomingWorkOrdersDaily[0] || []),
        ...(this.todayWorkOrders[0] || []),
        ...(this.todayWorkOrdersDaily[0] || [])
      ];
    
      if (allWorkOrders.length === 0) {
        console.warn('Tüm workOrders dizileri boş veya tanımlanmamış!');
        return;
      }
    
      const workOrder = allWorkOrders.find(order => order.WorkOrderId === workOrderId);
    
      if (workOrder) {
        if (workOrder.OrderSourceId === 4) {
          this.$router.push({ name: 'WorkOrderTraining', query: { from: 'WorkOrderTraining', workOrderId } });
        } else {
          this.$router.push({ name: 'MyWorkOrder', query: { from: 'MyWorkOrders', workOrderId } });
        }
      } else {
        console.warn(`Belirtilen workOrderId (${workOrderId}) hiçbir workOrders listesinde bulunamadı.`);
      }
    },
    
    changeStatusWorkOrderControl(myWorkOrder, newStatusId) {
      if (myWorkOrder.OrderSourceId != newStatusId) {
        const self = this;

        const previousOrderStatus = self.statuses.find((status) => status.Id == myWorkOrder.OrderStatusId);
        const currentOrderStatus = self.statuses.find((status) => status.Id == newStatusId);
        if (currentOrderStatus.Id != self.workOrderStatuses.onHold) {
          swal.check(self, self.translate('are_you_sure'), self.translate('ask_status_update_from_to').formatString(myWorkOrder.WorkName, previousOrderStatus.Name, currentOrderStatus.Name)).then((e) => {
            if (e.value) {
              self.changeStatusWorkOrder(myWorkOrder, currentOrderStatus);
            }
          });
        } else {
          self.changeStatusWorkOrder(myWorkOrder, currentOrderStatus);
        }
      }
    },
    changeStatusWorkOrder(selectedWorkOrder, currentOrderStatus) {
      const self = this;
      blockui.pageBlock();
      self.$globalApiClient.workOrder.myWorkOrderUpdateStatus({ //self.$globalApiClient.workOrder.workOrderUpdateStatus({
        Id: selectedWorkOrder.WorkOrderId,
        OrderSourceId: selectedWorkOrder.OrderSourceId,
        OrderStatusId: currentOrderStatus.Id,
      }).then((response) => {
        if (response.data.IsSuccess) {
          toastr.success(self.translate('status_update_work_order_successfully').formatString(selectedWorkOrder.WorkName, selectedWorkOrder.OrderStatusName, currentOrderStatus.Name));
          self.init();
        } else {
          toastr.error(response.data.Message);
        }
        blockui.unBlockPage();
      }, (error) => {
        blockui.unBlockPage();
      });
    },
    getWorkOrdersBetweenDates(event, isOverdueWorkOrders) {
      const self = this;
      if (event.name !== 'change' || event.startDate === null || event.endDate === null) {
        return;
      }

      blockui.pageBlock();
      const startDate = moment(event.startDate, 'DD.MM.YYYY').format('YYYY-MM-DD');
      const endDate = moment(event.endDate, 'DD.MM.YYYY').format('YYYY-MM-DD');

      self.getWorkOrders(startDate, endDate, isOverdueWorkOrders);

      blockui.unBlockPage();
      this.$nextTick();
    },
    changeText(event) {
      const searchText = event.target.value.toLocaleLowerCase('tr-TR');
    
      const filters = [
          { type: 'overdue', workOrders: 'overdueWorkOrders', workOrdersTemp: 'overdueWorkOrdersTemp', workOrdersDaily: 'overdueWorkOrdersDaily', workOrdersDailyTemp: 'overdueWorkOrdersDailyTemp' },
          { type: 'today', workOrders: 'todayWorkOrders', workOrdersTemp: 'todayWorkOrdersTemp', workOrdersDaily: 'todayWorkOrdersDaily', workOrdersDailyTemp: 'todayWorkOrdersDailyTemp' },
          { type: 'upcoming', workOrders: 'upcomingWorkOrders', workOrdersTemp: 'upcomingWorkOrdersTemp', workOrdersDaily: 'upcomingWorkOrdersDaily', workOrdersDailyTemp: 'upcomingWorkOrdersDailyTemp' }
      ];
    
      filters.forEach(filter => {
          if (searchText) {
              Vue.set(this[filter.workOrders], 0, this[filter.workOrdersTemp][0].filter(wo =>
                  wo.WorkOrderId.toString().toLowerCase().includes(searchText) ||
                  wo.WorkName.toLocaleLowerCase('tr-TR').includes(searchText)
              ));
    
              Vue.set(this[filter.workOrdersDaily], 0, this[filter.workOrdersDailyTemp][0].filter(wo =>
                  wo.WorkOrderId.toString().toLowerCase().includes(searchText) ||
                  wo.WorkName.toLocaleLowerCase('tr-TR').includes(searchText)
              ));
          } else {
              Vue.set(this[filter.workOrders], 0, this[filter.workOrdersTemp][0]);
              Vue.set(this[filter.workOrdersDaily], 0, this[filter.workOrdersDailyTemp][0]);
          }
      });
      this.$nextTick();
    },
  },
  beforeDestroy() {
    this.$eventHub.$off('changeWOStatus');
  },
};